(function () {
  'use strict';

  function farbeNormalisieren(wert) {
    return String(wert ?? '').trim().toLowerCase()
      .replace(/ä/g, 'a').replace(/ö/g, 'o').replace(/ü/g, 'u').replace(/ß/g, 'ss')
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .replace(/ae/g, 'a').replace(/oe/g, 'o').replace(/ue/g, 'u');
  }

  function varianteFuerFarbe(varianten, farbe) {
    const gesucht = farbeNormalisieren(farbe);
    return varianten.find(v => v.available && gesucht && farbeNormalisieren(v.farbe) === gesucht)
      ?? varianten.find(v => v.available) ?? null;
  }

  function vorauswahlFarbe(farbe, suche = '', ersterBlock = false) {
    const override = ersterBlock ? new URLSearchParams(suche).get('farbe') : null;
    return override?.trim() ? override : farbe;
  }

  function addRequestBauen(id, sections) {
    return {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }], sections: sections.join(',') })
    };
  }

  async function warenkorbAblauf({ id, fetch: abrufen = globalThis.fetch, ziel, ereignisZiel = ziel,
    root = '/', meldung = () => {}, texte = {} }) {
    const fehlertext = texte.fehler || 'Das hat leider nicht geklappt. Bitte versuch es noch einmal.';
    const senden = (an, name, detail) => an.dispatchEvent(new CustomEvent(name, { bubbles: true, detail }));
    const sections = ['variant-added'];
    root = root.endsWith('/') ? root : root + '/';
    meldung('');
    senden(ereignisZiel, 'cart:prepare-bundled-sections', { sections });
    let json;
    try {
      const antwort = await abrufen(root + 'cart/add.js', addRequestBauen(id, sections));
      json = await antwort.json().catch(() => ({}));
      if (!antwort.ok) throw new Error(json.description || json.message || fehlertext);
    } catch (fehler) {
      meldung(fehler.message || fehlertext, true);
      senden(ereignisZiel, 'cart:refresh');
      return { ok: false, hinzugefuegt: false };
    }
    meldung(texte.erfolg || 'Liegt im Warenkorb.');
    try {
      const antwort = await abrufen(root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } });
      if (!antwort.ok) throw new Error('cart.js HTTP ' + antwort.status);
      const cart = await antwort.json();
      if (!Array.isArray(cart?.items)) throw new Error('cart.js ohne items');
      cart.sections = json.sections;
      senden(ziel, 'variant:add', { items: json.items ?? [], cart });
      senden(ereignisZiel, 'cart:change', { baseEvent: 'variant:add', cart });
      return { ok: true, hinzugefuegt: true, cart };
    } catch (_) {
      meldung(texte.nachladen || 'Liegt im Warenkorb. Bitte öffne den Warenkorb, um den aktuellen Stand zu sehen.');
      senden(ereignisZiel, 'cart:refresh');
      return { ok: false, hinzugefuegt: true };
    }
  }

  const logik = { farbeNormalisieren, varianteFuerFarbe, vorauswahlFarbe, addRequestBauen, warenkorbAblauf };
  if (typeof module !== 'undefined' && module.exports) module.exports = logik;
  if (typeof window === 'undefined' || !window.customElements) return;

  class AdtElement extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const signal = this.abort.signal;
      const start = () => { if (!signal.aborted) this.start(signal); };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true, signal });
      else start();
    }
    disconnectedCallback() { this.abort?.abort(); }
  }

  class AdtTasche extends AdtElement {
    start(signal) {
      this.querySelectorAll('[data-adt-artikel]').forEach(karte => {
        const varianten = JSON.parse(karte.querySelector('[data-adt-varianten]').textContent);
        const form = karte.querySelector('form');
        const knopf = karte.querySelector('[data-adt-kaufen]');
        const fehler = karte.querySelector('[data-adt-meldung]');
        const radios = Array.from(karte.querySelectorAll('[data-adt-farbe]'));
        const bild = karte.querySelector('[data-adt-bild]');
        const preis = karte.querySelector('[data-adt-preis]');
        const streichpreis = karte.querySelector('[data-adt-streichpreis]');
        let auswahl;
        let sendet = false;
        let nachladenNoetig = false;
        const aktualisiere = v => {
          auswahl = v;
          form.elements.namedItem('id').value = v?.id ?? '';
          radios.forEach(r => { r.checked = Boolean(v && farbeNormalisieren(r.value) === farbeNormalisieren(v.farbe)); });
          knopf.disabled = !v || sendet || nachladenNoetig;
          if (!v) return;
          const farbname = karte.querySelector('[data-adt-farbname]');
          if (farbname) farbname.textContent = v.farbe;
          preis.innerHTML = v.preis;
          streichpreis.innerHTML = v.streichpreis || '';
          streichpreis.hidden = !v.streichpreis;
          if (v.bild && bild) {
            bild.srcset = `${v.bildKlein} 400w, ${v.bild} 900w`;
            bild.src = v.bild;
            bild.alt = `${karte.dataset.titel}, ${v.farbe}`;
            bild.hidden = false;
          } else if (bild) bild.hidden = true;
        };
        aktualisiere(varianteFuerFarbe(varianten, vorauswahlFarbe(karte.dataset.farbe, window.location.search, karte.dataset.ersterBlock === 'true')));
        karte.addEventListener('change', event => {
          if (!event.target.matches('[data-adt-farbe]')) return;
          fehler.textContent = '';
          aktualisiere(varianteFuerFarbe(varianten, event.target.value));
        }, { signal });
        form.addEventListener('submit', async event => {
          event.preventDefault();
          if (!auswahl || sendet || nachladenNoetig) return;
          sendet = true;
          knopf.disabled = true;
          radios.forEach(r => { r.disabled = true; });
          knopf.setAttribute('aria-busy', 'true');
          try {
            const ergebnis = await warenkorbAblauf({ id: auswahl.id, fetch: window.fetch.bind(window), ziel: this,
              ereignisZiel: document.documentElement, root: window.Shopify?.routes?.root || '/',
              texte: { erfolg: this.dataset.erfolg, fehler: this.dataset.fehler, nachladen: this.dataset.nachladen },
              meldung: (text, istFehler) => { fehler.textContent = text; fehler.classList.toggle('adt-fehler', Boolean(istFehler)); }
            });
            nachladenNoetig = ergebnis.hinzugefuegt && !ergebnis.ok;
            if (ergebnis.hinzugefuegt && window.themeVariables?.settings?.cartType === 'page') {
              window.location.href = (window.Shopify?.routes?.root || '/') + 'cart';
            }
          } finally {
            sendet = false;
            radios.forEach(r => { r.disabled = !varianten.some(v => v.available && farbeNormalisieren(v.farbe) === farbeNormalisieren(r.value)); });
            knopf.removeAttribute('aria-busy');
            aktualisiere(auswahl);
          }
        }, { signal });
      });
    }
  }

  const spielen = video => {
    const versuch = video.play();
    if (versuch?.catch) versuch.catch(() => {});
  };

  class AdtHero extends AdtElement {
    start(signal) {
      const videos = Array.from(this.querySelectorAll('video'));
      const ton = this.querySelector('[data-adt-ton]');
      const reduziert = window.matchMedia('(prefers-reduced-motion: reduce)');
      const desktop = window.matchMedia('(min-width: 1000px)');
      const aktiv = () => videos.find(v => v.dataset.adtVideo === (desktop.matches ? 'desktop' : 'mobil')) || videos[0];
      const tonAnzeige = () => {
        const mitTon = Boolean(aktiv() && !aktiv().muted);
        if (ton) { ton.textContent = mitTon ? this.dataset.tonAus : this.dataset.tonAn; ton.setAttribute('aria-pressed', String(mitTon)); }
      };
      const abgleichen = () => {
        videos.forEach(v => {
          if (v !== aktiv() || reduziert.matches || document.hidden) { v.pause(); v.muted = true; }
          else if (this.dataset.autoplay === 'true') { v.muted = true; spielen(v); }
        });
        tonAnzeige();
      };
      videos.forEach(v => {
        v.addEventListener('playing', () => { this.querySelector('[data-adt-poster]')?.setAttribute('hidden', ''); }, { signal });
        v.addEventListener('volumechange', tonAnzeige, { signal });
        // Stummer Autoplay springt über das Intro; mit Ton läuft die Folge ab 0.
        const startStumm = parseFloat(this.dataset.start) || 0;
        if (startStumm > 0) v.addEventListener('timeupdate', () => { if (v.muted && v.currentTime < startStumm - 0.2) v.currentTime = startStumm; }, { signal });
      });
      ton?.addEventListener('click', () => {
        const video = aktiv();
        if (!video) return;
        if (video.muted) { video.currentTime = 0; video.muted = false; spielen(video); }
        else video.muted = true;
        tonAnzeige();
      }, { signal });
      reduziert.addEventListener('change', abgleichen, { signal });
      desktop.addEventListener('change', abgleichen, { signal });
      document.addEventListener('visibilitychange', abgleichen, { signal });
      signal.addEventListener('abort', () => videos.forEach(v => v.pause()), { once: true });
      abgleichen();
    }
  }

  class AdtFolgen extends AdtElement {
    start(signal) {
      const videos = Array.from(this.querySelectorAll('video'));
      const sichtbar = new Set();
      const reduziert = window.matchMedia('(prefers-reduced-motion: reduce)');
      const abgleichen = () => videos.forEach(v => {
        const spielenErlaubt = sichtbar.has(v) && !reduziert.matches && !document.hidden;
        const poster = v.parentElement.querySelector('[data-adt-poster]');
        if (spielenErlaubt) { v.muted = true; spielen(v); }
        else { v.pause(); if (poster) poster.hidden = false; }
      });
      videos.forEach(v => v.addEventListener('playing', () => {
        const poster = v.parentElement.querySelector('[data-adt-poster]');
        if (poster) poster.hidden = sichtbar.has(v) && !reduziert.matches && !document.hidden;
      }, { signal }));
      if (!('IntersectionObserver' in window)) return;
      const observer = new IntersectionObserver(eintraege => {
        eintraege.forEach(e => {
          const video = e.target.querySelector('video');
          if (e.isIntersecting && e.intersectionRatio >= 0.5) sichtbar.add(video);
          else sichtbar.delete(video);
        });
        abgleichen();
      }, { threshold: [0, 0.5] });
      videos.forEach(v => observer.observe(v.closest('[data-adt-folge]')));
      reduziert.addEventListener('change', abgleichen, { signal });
      document.addEventListener('visibilitychange', abgleichen, { signal });
      signal.addEventListener('abort', () => { observer.disconnect(); videos.forEach(v => v.pause()); }, { once: true });
    }
  }

  for (const [name, klasse] of [['adt-tasche', AdtTasche], ['adt-hero', AdtHero], ['adt-folgen', AdtFolgen]]) {
    if (!customElements.get(name)) customElements.define(name, klasse);
  }
})();
